interface IIdGeneratorArgs {
    length?: number;
}

const ALPHABET_CHARACTERS = "abcdefghijklmnopqrstuvwxyz";
const SPECIAL_CHARACTERS = "-.#@$&*";
const NUMBER_CHARACTERS = "0123456789";
const DEFAULT_CHARACTERS = [ALPHABET_CHARACTERS, SPECIAL_CHARACTERS, NUMBER_CHARACTERS].join("");

const DEFAULT_ID_LENGTH = 12;

const nanoid = (args?: IIdGeneratorArgs) => {
    const idLength = args?.length || DEFAULT_ID_LENGTH;
    let uuid = "";

    for (let index = 0; index < idLength; index++) {
        const randomIndex = Math.floor(Math.random() * DEFAULT_CHARACTERS.length);
        uuid += DEFAULT_CHARACTERS[randomIndex];
    }

    return uuid;
};
export default nanoid;
